<template>
  <div class="form-modal-title">
    <div class="form-modal-title__text">
      {{ title }}
    </div>
    <Lines class="form-modal-title__lines" />
    <div class="form-modal-title__step form-modal-title__step_first">
      1
      <svg
        class="form-modal-title__icon"
        viewBox="0 0 18 14"
        fill="none"
      ><path
        d="M1.5 7.5L7 13L17 1.5"
        stroke="#4FCDB0"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      /></svg>
    </div>
    <div class="form-modal-title__step form-modal-title__step_second">
      2
    </div>
  </div>
</template>

<script>
  import Lines from '@/assets/svg/lines.svg'
  export default {
    name: 'FormModalTitle',

    components: {
      Lines
    },

    props: {
      title: {
        ttpe: String,
        default: ''
      }
    }
    
  }
</script>

<style lang="scss">
.form-modal-title {
  width: 100%;
  max-width: 1182px;
  position: relative;
  padding-left: 115px;
  margin-bottom: 60px;

  @include mobile {
    padding-left: 16px;
    margin-bottom: 45px;
  }

  &__text {
    width: 100%;
    max-width: 500px;
    font-size: 54px;
    line-height: 1.18;
    font-weight: 700;
    text-transform: uppercase;

    @include mobile {
      font-size: 24px;
      line-height: 28px;
      max-width: 220px;
    }
  }

  &__lines {
    position: absolute;
    width: 100%;
    height: 16px;
    top: 65px;
    left: 0;
    z-index: -1;

    @include mobile {
      top: 24px;

      rect {
        &:nth-child(2) {
          y: 4;
        }

        &:nth-child(3) {
          y: 8;
        }
      }
    }
  }

  &__icon {
    display: none;
  }

  &__step {
    position: absolute;
    top: 40px;
    right: 200px;
    width: 64px;
    height: 64px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    line-height: 1.34;
    border-radius: 50%;
    border: 2px solid $c-red;
    color: $c-red;
    background-color: $c-white;

    @include tablet {
      right: 130px;
    }

    @include mobile {
      width: 32px;
      height: 32px;
      font-size: 14px;
      top: 14px;
      right: 65px;
    }

    &::before {
      position: absolute;
      top: 0;
      left: -22px;
      width: 104px;
      height: 100%;
      background-color: $c-white;
      content: '';
      z-index: -1;
      
      @include mobile {
        width: 52px;
        left: -10px;
      }
    }

    &_second {
      left: auto;
      right: 0;
      border-color: #797979;
      color: #797979;
    }
  }

  &_second-step {
    .form-modal-title__step_first {
      border-color: $c-green;
      font-size: 0;
    }

    .form-modal-title__icon {
      width: 22px;
      height: 16px;
      display: block;

      @include mobile {
        width: 10px;
        height: 10px;
      }
    }

    .form-modal-title__step_second {
      border-color: $c-red;
      color: $c-red;
    }
  }
}
</style>
